import { render } from "./BalancePlayer.vue?vue&type=template&id=31bafede&scoped=true"
import script from "./BalancePlayer.vue?vue&type=script&lang=js"
export * from "./BalancePlayer.vue?vue&type=script&lang=js"

import "./BalancePlayer.vue?vue&type=style&index=0&id=31bafede&scoped=true&lang=css"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bafede"]])

export default __exports__